"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyForRefund = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var data_1 = require("../../data");
var payout_1 = require("../../utils/payout");
var session_storage_1 = require("../../utils/session-storage");
var ui_1 = require("./ui");
var components_1 = require("./ui/components");
exports.ApplyForRefund = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var _c;
    var accountId = _a.accountId, customerId = _a.customerId;
    var _d = (0, data_1.useEligibleForPayout)(accountId, customerId), data = _d.data, loading = _d.loading, error = _d.error;
    var Redirect = (0, core_1.useComponents)().Redirect;
    var refundNotEligible = (0, core_1.useLinks)().refundNotEligible;
    var payoutAccount = (0, session_storage_1.getPayoutAccount)(accountId);
    var isPayoutRequested = payoutAccount &&
        payoutAccount.payoutRequested &&
        payoutAccount.expiresAt > Date.now();
    if (error) {
        return react_1.default.createElement(components_1.Error, null);
    }
    if (loading || !data) {
        return react_1.default.createElement(components_1.Loading, null);
    }
    if (!(0, payout_1.isEligibleForPayout)(data)) {
        return (react_1.default.createElement(Redirect, { to: {
                pathname: refundNotEligible(),
                search: "?reason=".concat((_c = data.reasonCode) !== null && _c !== void 0 ? _c : ''),
            } }));
    }
    if (isPayoutRequested) {
        return (react_1.default.createElement(Redirect, { to: {
                pathname: refundNotEligible(),
                search: "?reason=PAYOUT_ALREADY_REQUESTED",
            } }));
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.APPLY_FOR_REFUND, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(ui_1.ApplyForRefundUI, { accountId: accountId, customerId: customerId, eligibilityData: data })));
}, components_1.Loading);
